import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  warningModalTitle: {
    id: 'KEQbB0',
    description:
      'Title of the dismissable warning modal shown at print time when the Warn enforcement level is selected and a required serial number is missing',
    defaultMessage: 'Missing Serial Number',
  },
  warningModalBody: {
    id: 'sEyCay',
    description: 'Body text of the dismissable warning modal shown at print time when a required serial number is missing',
    defaultMessage: 'One or more items require a serial number. You can still print, but the serial will be missing from the record.',
  },
  warningModalProceed: {
    id: 'QQxZbq',
    description: 'Button that dismisses the warning and continues printing the label without the missing serial',
    defaultMessage: 'Print Anyway',
  },
  warningModalCancel: {
    id: 'zHv/tZ',
    description: 'Button that cancels the print action so the packer can enter the missing serial first',
    defaultMessage: 'Cancel',
  },
  printBlockedTooltip: {
    id: 'gxT4dJ',
    description:
      'Tooltip on a disabled print/label button when the Block enforcement level is selected and a required serial number is missing',
    defaultMessage: 'A required serial number is missing. Enter it to enable printing.',
  },
});
